// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dept-multi-card .customCardbody {\n  max-height: 500px;\n  margin: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
